module.exports = __webpack_public_path__ + "static/media/screen4-1x.ef98a943.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Phone/screen4-1x.jpg
// module id = 49
// module chunks = 0